import { WidgetChartOptions } from 'app/modules/widget/components/widget-chart/widget-chart.component';
import { Comment, Dashboard, Widget } from 'app/providers/bridge-api/dashboard.service';
import {
  AbstractChartReport,
  CommentDataChange,
} from '../chart-report-abstract/chart-report-abstract';
import { ChartDataService } from '../../chart-data.service';

export class ScatterPlotChartReport extends AbstractChartReport {
  reportName = 'featureScatterPlot';
  reportHandler = ChartDataService.forScatterPlot;

  getFields(): string[] {
    return [];
  }

  canSort(): boolean {
    return false;
  }

  getGraphTypes() {
    return ['scatter'];
  }

  public canSetChartMaximumHorizontal(): boolean {
    return true;
  }

  isAnalyticItemSupported(key) {
    return 'documents' !== key;
  }

  public applyComparisonToSeries(_comparison: any, _series: any, _seriesIdx: any): void {
    return;
  }

  getCommentDataChange(
    comment: Comment,
    widget: Widget<WidgetChartOptions>,
    dashboard: Dashboard,
    series,
    _dataProp = 'y'
  ): CommentDataChange {
    const yChange = super.getCommentDataChange(comment, widget, dashboard, series, 'y');
    const xChange = super.getCommentDataChange(comment, widget, dashboard, series, 'x');

    if (yChange || xChange) {
      return { ...(yChange ?? {}), ...(xChange ?? {}) } as CommentDataChange;
    }
  }

  public getParams() {
    const params = super.getParams();

    params.axisX = this.options.xAxis;
    params.axisY = this.options.yAxis;

    if (params.axisX.includes('impact')) {
      params.axisX = 'volume';
    }

    if (params.axisY.includes('impact')) {
      params.axisY = 'volume';
    }

    params.boxSize = this.options.boxSize;
    params.scoringStrategy = this.options.scoringStrategy;
    params.boxDirection = this.options.boxDirection;
    params.scoreRange = this.options.scoreRange;

    return params;
  }
}
